/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'townsquare-comments.comment-action-bar.delete-button': 'Excluir',
  'townsquare-comments.comment-action-bar.edit-button': 'Editar',
  'townsquare-comments.comment-action-bar.reply-button': 'Responder',
  'townsquare-comments.comment.edited-date': 'editado {time}',
  'townsquare-comments.comments.comments-title':
    '{itemCount, plural, =0 {Comentários} one {{itemCount,number} comentário} other {{itemCount,number} comentários}}',
};
